import { useEffect, useState } from 'react'
import {
  Attachment,
  previewTemplatePayloadType,
  resetSelectedManualCommunicationState,
  sendTemplatePreviewPayload,
  hideLoader,
  addToaster,
  showLoader,
  ErrorResponse,
  getPreviewTemplateByCaseidAndTemplateId,
  selectedManualCommunication,
  faxOutboundDataType,
  sendCommunicationTemplateToRecipientApiV3,
  sendTemplatePayloadV3ApiEnhancementType,
  WORKFLOW_UI_IDENTIFIER,
} from '@app-store'
import { FormProvider, useForm } from 'react-hook-form'
import { COMM_TEMPLATE, WORKFLOW_STATUS } from '../../utils/constants'
import {
  loadCSSAndBuildHTMLForSendingCommunication,
  // makeEditableWithRedBackground,
  // removeEditableAndRedBackground,
} from '../../utils/helperFunctions'
import { v4 as uuid } from 'uuid'
import './SendManualCommunication.css'
import { AxiosError } from 'axios'
import { useAppDispatch } from '../../utils/agent.store'
import { SendManualCommunicationProps } from './SendManualCommunication.type'
import { ViewObjectEntry } from '../../types/types'
import { CORRESPONDENCE_LOGS_STRINGS } from '../../utils/strings'
import TextOutboundTaskBox from './TextOutboundTaskBox'
// import CaseDocumentDropdown from './CaseDocumentsDropdown'
// import FaxOutboundTaskBox from './FaxOutboundTaskBox'
// import MailOutboundTaskBox from './MailOutboundTaskBox'

const OutboundTask: React.FC<SendManualCommunicationProps> = (
  props: SendManualCommunicationProps
) => {
  const isManualFaxOutboundTask =
    props?.task?.identifier?.ui_identifier ===
    WORKFLOW_UI_IDENTIFIER.FAX_OUTBOUND_TASK

  const faxOutboundFormData: faxOutboundDataType = {
    case_id: props.caseId,
    template_name: (props.preSelectedTemplateId as unknown as string) ?? '',
    mode_of_communication: '',
    program: props.programId,
    service: props.serviceId,
    caseDocuments: [],
  }
  const dispatch = useAppDispatch()

  const [previewTemplateData, setPreviewTemplateData] =
    useState<selectedManualCommunication | null>(null)

  const [previewDataWithLink, setPreviewDataWithLink] = useState<string | null>(
    null
  )

  const [editState, setEditState] = useState<boolean>(false)
  const [attachments, setAttachments] = useState<Attachment[]>([])
  const [previewData, setPreviewData] = useState<string>('')
  const [updatedData, setUpdatedData] = useState<string | null>(null)
  //  const [previewMap, setPreviewMap] = useState<{ [key: string]: string }>({})
  const [attachmentsKey, setAttachmentsKey] = useState<Attachment[]>()

  const [envelopeId, setEnvelopeId] = useState<string>('')
  const [viewObjects, setViewObjects] = useState<ViewObjectEntry[]>([])

  const [isSendButtonDisabled, setIsSendButtonDisabled] =
    useState<boolean>(true)

  const methods = useForm({
    defaultValues: faxOutboundFormData,
  })

  const { watch, setValue, trigger } = methods

  //   const handleAttachmentDeleteClick = (itemToDelete: Attachment) => {
  //     const updatedAttachments = attachments.filter((item) => {
  //       if (itemToDelete.id !== undefined) {
  //         return item.id !== itemToDelete.id
  //       }
  //       return item.unique_attachment_name !== itemToDelete.unique_attachment_name
  //     })
  //     const selectedAttachments = watch('caseDocuments')
  //     const filteredCaseDocuments = selectedAttachments?.filter(
  //       (item) => item !== itemToDelete?.id
  //     )
  //     setValue('caseDocuments', filteredCaseDocuments)

  //     setAttachments(updatedAttachments)

  //     const updatedAttachmentsKey = updatedAttachments.map(
  //       (item: Attachment) => ({
  //         id: item?.id,
  //         unique_attachment_name: item?.unique_attachment_name,
  //         attachment_name: item?.attachment_name,
  //         attachment_document_type: item?.attachment_document_type,
  //         attachment_type: item?.attachment_type,
  //         attachment_document_id: item?.attachment_document_id,
  //         include_editable_text: item?.include_editable_text,
  //         contains_docusign: item?.contains_docusign,
  //         ...(item?.path ? { path: item.path } : {}),
  //         source: item?.source,
  //       })
  //     )

  //     setAttachmentsKey(updatedAttachmentsKey)
  //   }

  const sendCommunicationTemplateFunction = async (
    payload: sendTemplatePayloadV3ApiEnhancementType
  ) => {
    try {
      dispatch(showLoader())
      const response = await sendCommunicationTemplateToRecipientApiV3(
        {
          sendPayload: payload,
          envelopeId: envelopeId,
        },
        props?.programId,
        props?.serviceId
      )
      if (response.data) {
        await props?.updateTaskResource?.(props?.task, {
          resource_id: response?.data?.id,
          communication_id: response?.data?.id,
          template_id: watch('template_name'),
        })

        dispatch(
          addToaster({
            message: `${payload?.correspondence_type}${COMM_TEMPLATE.SUCCESSFULLY_QUEUED}`,
            type: 'success',
            id: uuid(),
          })
        )
      }

      dispatch(resetSelectedManualCommunicationState())
      setEnvelopeId('')
    } catch (err) {
      console.error(err)
      if (
        ((err as AxiosError)?.response?.data as ErrorResponse)?.message ===
        COMM_TEMPLATE?.CONFLICT_RECIPIENT_API_MESSAGE
      ) {
        dispatch(
          addToaster({
            message: COMM_TEMPLATE?.CONFLICT_RECIPIENT_TOASTER_MESSAGE,
            type: 'error',
            id: uuid(),
          })
        )
      } else {
        dispatch(
          addToaster({
            message: `${COMM_TEMPLATE.FAILED_TO_QUEUE} ${payload?.correspondence_type}`,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } finally {
      dispatch(hideLoader())
    }
  }

  const sendCommunicationTemplate = async () => {
    const result = await trigger()
    if (!result) return
    const sendEdit: sendTemplatePreviewPayload = {
      type: 0,
      // editableValues: previewMap,
      editableValues: {},
    }
    const sendPayload = [sendEdit]
    if (attachmentsKey === undefined) {
      setAttachmentsKey(attachments)
    }
    const finalAttachments = (attachmentsKey ?? attachments)?.map(
      (item: Attachment) => ({
        attachment_name: item?.attachment_name,
        attachment_document_type: item?.attachment_document_type,
        attachment_type: CORRESPONDENCE_LOGS_STRINGS.CUSTOM,
        attachment_document_id: item?.attachment_document_id,
        include_editable_text: item?.include_editable_text,
        contains_docusign: item?.contains_docusign,
        ...(item?.path ? { path: item?.path + '/' + item?.awsFileName } : {}),
      })
    )
    if (isManualFaxOutboundTask && !finalAttachments?.length) {
      dispatch(
        addToaster({
          message: COMM_TEMPLATE?.ATTACHMENT_VALIDATION_WHILE_SENDING_MSG,
          type: 'error',
          id: uuid(),
        })
      )
      return
    }
    const additionalFields = {
      recipient_to: [watch('to') ?? ''],
      correspondence_type: COMM_TEMPLATE.SMS,
      attachment: finalAttachments,
      recipient_cc: [],
      recipient_bcc: [],
    }
    const payload = {
      case_id: parseInt(watch('case_id')),
      template_id: parseInt(watch('template_name')),
      service_id: parseInt(props?.serviceId),
      product_id: parseInt(props?.productId),
      program_id: parseInt(props?.programId),
      body: loadCSSAndBuildHTMLForSendingCommunication(previewData) ?? '',
      editable_fields: sendPayload,
      view_object: viewObjects,
      ...additionalFields,
    }
    sendCommunicationTemplateFunction(payload)
  }

  useEffect(() => {
    ;(async () => {
      if (!props.task || !props.task?.identifier?.template_id) return
      const resourceId = props.task.resource_id
      const isCompleted = props.task.state === WORKFLOW_STATUS.COMPLETED

      if (resourceId && isCompleted) {
        const data = watch()
        const payload: previewTemplatePayloadType = {
          caseId: parseInt(data?.case_id),
          templateId: parseInt(props.task?.identifier?.template_id),
          isEditable: true,
          programId: parseInt(data?.program),
        }
        const response = await getPreviewTemplateByCaseidAndTemplateId(
          payload,
          props?.programId,
          props?.serviceId
        )
        setPreviewTemplateData(response.data)
      }
    })()
  }, [props.task, watch])

  const onSubmit = async () => {
    const data = watch()
    try {
      dispatch(showLoader())
      const payload: previewTemplatePayloadType = {
        caseId: parseInt(data?.case_id),
        templateId: parseInt(data?.template_name),
        resourceId: parseInt(data?.template_name),
        isEditable: true,
        programId: parseInt(data?.program),
      }
      const response = await getPreviewTemplateByCaseidAndTemplateId(
        payload,
        props?.programId,
        props?.serviceId
      )
      if (response) {
        setIsSendButtonDisabled(false)
      }
      setPreviewTemplateData(response.data)
      setUpdatedData(null)
      setEditState(false)
      const attachmentArray = response?.data?.attachment?.map(
        (item: Attachment) => ({
          ...item,
          source: COMM_TEMPLATE.SMS_TEMPLATE, // changed
        })
      )
      setAttachments(attachmentArray)
      setAttachmentsKey(attachmentArray)
      setValue('caseDocuments', [])
    } catch (error) {
      console.error(error)
      setIsSendButtonDisabled(true)
    } finally {
      dispatch(hideLoader())
    }
  }

  //   const fetchFilePreviewUrl = async (path: string, fileName: string) => {
  //     try {
  //       dispatch(showLoader())
  //       const response = await axiosInstance.get(
  //         `${API_END_POINT.CORE}v1/files/generate-download-url?fileName=${path}/${fileName}`,
  //         {
  //           headers: {
  //             'x-tenantid': selectedTenantId,
  //           },
  //         }
  //       )
  //       if (response.data) {
  //         setPreviewUrl(response.data?.url)
  //         downloadUrl.current = response.data?.url
  //       }
  //     } catch (error) {
  //       console.error(CORRESPONDENCE_LOGS_STRINGS.API_ERROR, error)
  //       setPreviewUrl('')
  //       downloadUrl.current = ''
  //     } finally {
  //       dispatch(hideLoader())
  //     }
  //   }

  //   const handleViewClick = async (filename: string, path?: string) => {
  //     await fetchFilePreviewUrl(path ?? '', filename ?? '')
  //     setIsOpenModal(true)
  //     setStaticFileName(filename)
  //   }

  //   const getClassOnEditState = (editState: boolean) =>
  //     editState ? 'bg-accent-0 with-shadow' : 'bg-accent-100'

  //   const handleSave = () => {
  //     if (!isEmpty(editableRef.current)) {
  //       const updatedHtml = editableRef?.current?.innerHTML

  //       const parser = new DOMParser()
  //       const doc = parser.parseFromString(updatedHtml, 'text/html')
  //       const editableDivs = doc.querySelectorAll('div')

  //       const initialPreviewMap: { [key: string]: string } = {}

  //       editableDivs.forEach((div) => {
  //         if (div.className.startsWith('editable')) {
  //           const innerText = div.innerText

  //           div.innerHTML = `<span style="background-color: inherit" contenteditable="false">${innerText}</span>`

  //           const className = div.getAttribute('class')?.toString()
  //           if (className) {
  //             initialPreviewMap[className] = innerText
  //           }
  //         }
  //       })
  //       setPreviewMap((prevMap) => ({ ...prevMap, ...initialPreviewMap }))
  //       const updatedHtmlWithChanges = doc.documentElement.innerHTML
  //       setUpdatedData(updatedHtmlWithChanges)
  //     }
  //     setEditState(false)
  //   }

  //   const handleAttachmentEditClick = async (item: Attachment, type: string) => {
  //     setDocumentType(item?.attachment_document_type)
  //     if (
  //       item?.attachment_document_type === COMM_TEMPLATE.STATIC_DOCUMENT_UPPERCASE
  //     ) {
  //       if (isWordOrExcelOrCsvDocument(item?.attachment_name)) {
  //         await fetchFilePreviewUrl(item?.path ?? '', item?.awsFileName ?? '')
  //         getDownloadURL(
  //           dispatch,
  //           props?.caseId,
  //           downloadUrl.current,
  //           item?.attachment_name
  //         )
  //       } else {
  //         handleViewClick(item?.awsFileName ?? '', item?.path ?? '')
  //       }
  //     } else {
  //       const attachmentInfo = previewTemplateData?.attachment?.find(
  //         (value) => value.id === item?.id
  //       )
  //       try {
  //         dispatch(showLoader())
  //         const pdfData = await fetchDocumentPdfByTemplateIdCaseId(
  //           parseInt(props?.caseId) ?? 0,
  //           item.attachment_document_id ?? 0
  //         )
  //         if (pdfData?.documentType === COMM_TEMPLATE.DOCX_UPPERCASE) {
  //           handleViewClick(item?.attachment_name, pdfData?.pdfData)
  //           return
  //         }
  //         setTimeout(() => {
  //           setAttachmentData(pdfData?.pdfData)
  //         }, 0)
  //       } catch (error) {
  //         console.error('Error fetching PDF data:', error)
  //         setAttachmentData('')
  //       } finally {
  //         dispatch(hideLoader())
  //       }
  //       if (attachmentInfo || attachmentData) {
  //         setModal({
  //           type: type === MODAL_TYPES.LINK ? MODAL_TYPES.VIEW : MODAL_TYPES.EDIT,
  //           state: true,
  //         })
  //         setTimeout(() => {
  //           setAttachmentBody(attachmentInfo)
  //         }, 0)
  //       }
  //     }
  //   }

  useEffect(() => {
    setEnvelopeId('')
  }, [watch('template_name'), watch])

  useEffect(() => {
    setViewObjects(previewTemplateData?.view_object ?? [])
    if (!previewTemplateData) {
      setUpdatedData(null)
      setEditState(false)
    }
  }, [previewTemplateData])

  useEffect(() => {
    setPreviewData(
      updatedData ?? previewDataWithLink ?? previewTemplateData?.body ?? ''
    )
  }, [editState, previewTemplateData])

  return (
    <FormProvider {...methods}>
      {/* <div className="flex flex-col font-primary bg-accent-0">
        <form className="py-4" method="POST" onSubmit={handleSubmit(onSubmit)}>
          <div className="pl-3 pt-3 pr-3 bg-accent-0 shadow-md pb-3">
            {!isMailOutboundTask ? (
              <FaxOutboundTaskBox
                isSendButtonDisabled={isSendButtonDisabled}
                setIsSendButtonDisabled={setIsSendButtonDisabled}
                previewTemplateData={previewTemplateData}
                setPreviewTemplateData={setPreviewTemplateData}
                onSubmit={onSubmit}
                sendCommunicationTemplate={sendCommunicationTemplate}
                previewDataWithLink={previewDataWithLink}
                setPreviewDataWithLink={setPreviewDataWithLink}
                {...props}
              />
            ) : (
              <MailOutboundTaskBox
                isSendButtonDisabled={isSendButtonDisabled}
                setIsSendButtonDisabled={setIsSendButtonDisabled}
                previewTemplateData={previewTemplateData}
                setPreviewTemplateData={setPreviewTemplateData}
                onSubmit={onSubmit}
                sendCommunicationTemplate={sendCommunicationTemplate}
                previewDataWithLink={previewDataWithLink}
                setPreviewDataWithLink={setPreviewDataWithLink}
                {...props}
              />
            )}
            {previewTemplateData && (
              <>
                <CaseDocumentDropdown
                  caseId={props?.caseId}
                  setAttachments={setAttachments}
                  setAttachmentsKey={setAttachmentsKey}
                  isDisabled={props?.isDisabled ?? false}
                  tabIndexOffSet={props?.tabIndexOffset}
                  errors={errors}
                  setValue={setValue}
                  control={control as unknown as Control<FieldValues>}
                  attachments={attachments}
                  attachmentKey={attachmentsKey}
                />
                {!props?.isDisabled && (
                  <DraggableAttachableList
                    label={COMM_TEMPLATE?.FAX_ATTACHMENTS}
                    setAttachmentsKey={setAttachmentsKey}
                    setAttachments={setAttachments}
                    attachments={attachments}
                    handleViewClick={handleViewClick}
                    handleAttachmentEditClick={handleAttachmentEditClick}
                    handleAttachmentDeleteClick={handleAttachmentDeleteClick}
                    tabIndexOffset={props?.tabIndexOffset}
                    hideUploadButton
                  />
                )}
              </>
            )}
          </div>

          {previewTemplateData && (
            <div className="bg-accent-0 shadow-md pl-3 pr-3 pb-3 ">
              <div
                className={`template-data ${getClassOnEditState(
                  editState
                )} mt-4 p-3 border-t-[2px] border-t-accent-900`}
              >
                <div className="flex justify-between">
                  <span className="text-base">
                    {!editState && COMM_TEMPLATE.COVERSHEET_PREVIEW}
                    {editState && COMM_TEMPLATE.REVIEW_EDITABLE_TEXT}
                  </span>
                  {previewTemplateData?.include_editable_text && !editState && (
                    <button
                      onClick={() => {
                        setEditState(true)
                      }}
                    >
                      {<SvgEdit />}
                    </button>
                  )}
                  {editState && (
                    <div className="flex gap-4">
                      <CustomButton
                        dataQaId="cancel-edit-body-preview"
                        type="button"
                        color="primary"
                        widthClass="w-[5.563rem]"
                        className="text-sm"
                        isFilled={false}
                        onClick={() => {
                          setEditState(false)
                          setPreviewData(
                            previewDataWithLink ?? previewTemplateData.body
                          )
                        }}
                      >
                        <span className="text-sm font-light">
                          {NAMESPACES_MANUAL_COMMUNICATION.CANCEL}
                        </span>
                      </CustomButton>
                      <CustomButton
                        dataQaId="save-edit-updated-html"
                        type="button"
                        color="primary"
                        widthClass="w-[5.563rem]"
                        className="text-sm"
                        isFilled={true}
                        onClick={handleSave}
                      >
                        <span className="text-sm font-light">
                          {NAMESPACES_MANUAL_COMMUNICATION.SAVE}
                        </span>
                      </CustomButton>
                    </div>
                  )}
                </div>
                {
                  <div className="flex editer-wrap justify-center">
                    <div className="w-[49.5rem] min-h-[21cm] with-shadow ck-content document-editor__editable-container bg-accent-0 p-4 border-t-2 border-secondary-450">
                      <PdfViewer
                        pdfUrl={previewData}
                        isBase64
                        allowZoom={false}
                        showPageNumber={false}
                        defaultZoomScale={1.3}
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          )}
        </form>
        {isOpenModal && (
          <div className="a4modal">
            <Modal
              isOpen={true}
              closeModal={() => {
                setIsOpenModal(false)
              }}
              showCloseButton={false}
            >
              <div className="flex flex-col">
                <div className="flex justify-between items-center">
                  <div className="font-bold text-lg">
                    <span>{COMM_TEMPLATE?.VIEW_DOCUMENT} - </span>
                    <span>{staticFileName}</span>
                  </div>

                  <div className="flex itens-center">
                    <button
                      className="mr-5 cursor-pointer"
                      onClick={() =>
                        getDownloadURL(
                          dispatch,
                          caseKey ?? watch('case_id'),
                          previewUrl,
                          staticFileName
                        )
                      }
                      data-qa-id="download-file"
                    >
                      <SvgDownloadGrey />
                    </button>
                    <button
                      className="flex items-center justify-center h-[1rem] w-[1rem] cursor-pointer"
                      onClick={() => setIsOpenModal(false)}
                    >
                      <SvgCross height={'0.875rem'} width={'0.875rem'} />
                    </button>
                  </div>
                </div>
                <div className="px-3 py-[1rem] border border-border-100 ck-content doc-wrap-height mt-4">
                  <iframe
                    title="file preview"
                    src={`${previewUrl}#toolbar=0&navpanes=0`}
                    style={{ border: 0 }}
                    height="500"
                    className="w-full max-w-full min-w-[800px]"
                  />
                </div>
              </div>
            </Modal>
          </div>
        )}
        {/* TODO: Improove this functionality while working on 23348 */}
      {/* {modal.state && (
          <div className="a4modal">
            <Modal
              isOpen={modal.state}
              closeModal={() => setModal({ type: '', state: false })}
              showCloseButton={false}
              closeModalOnOutsideClick={false}
              className="border rounded-none"
            >
              <div className="flex flex-col w-[49.5rem]">
                <div className="flex justify-between items-center">
                  <div className="font-medium text-lg">
                    <span>{COMM_TEMPLATE.VIEW_DOCUMENT} - </span>

                    <span>{attachmentBody?.attachment_name}</span>
                  </div>
                  <div className="flex itens-center">
                    <button
                      className="mr-5 cursor-pointer"
                      onClick={() =>
                        getDownloadURL(
                          dispatch,
                          caseKey ?? watch('case_id'),
                          attachmentData,
                          attachmentBody?.attachment_name,
                          documentType
                        )
                      }
                      data-qa-id="download-file"
                    >
                      <SvgDownloadGrey />
                    </button>

                    <div
                      className="flex items-center justify-center h-[1rem] w-[1rem] cursor-pointer"
                      onClick={() => setModal({ type: '', state: false })}
                    >
                      <SvgCross height={'0.875rem'} width={'0.875rem'} />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-between mt-4">
                  {modal.type !== MODAL_TYPES.EDIT && (
                    <div
                      className={`border border-accent-200 w-full document-editor__editable-container-view mt-2 bg-white overflow-clip`}
                    >
                      <PdfViewer
                        pdfUrl={attachmentData}
                        isBase64
                        allowZoom={false}
                        showPageNumber={false}
                        defaultZoomScale={1.3}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          </div>
        )} */}
      {/* </div> */}
      <div className="flex flex-col font-primary bg-accent-0 py-4">
        <TextOutboundTaskBox
          isSendButtonDisabled={isSendButtonDisabled}
          setIsSendButtonDisabled={setIsSendButtonDisabled}
          previewTemplateData={previewTemplateData}
          setPreviewTemplateData={setPreviewTemplateData}
          onSubmit={onSubmit}
          sendCommunicationTemplate={sendCommunicationTemplate}
          previewDataWithLink={previewDataWithLink}
          setPreviewDataWithLink={setPreviewDataWithLink}
          {...props}
        />
      </div>
    </FormProvider>
  )
}
export default OutboundTask
